export function validateBreak(priceToBreak) {
  if (!priceToBreak || priceToBreak === '')
    return [false, 'Must enter a price to break.'];
  if (Number(priceToBreak) <= 0)
    return [false, 'Break Price must be larger than zero.'];
  return [true, ''];
}
